module.exports = __webpack_public_path__ + "media/images/logo-1ecee8fd31b1418e5637b5428cddca06.svg";